import { useEffect } from 'react';
import PDFObject from 'pdfobject';

function useEmbedPdf(
  endpoint,
  embedId,
  passedOptions = {
    pdfOpenParams: {
      view: 'FitH',
    },
    title: 'PDF Document',
  },
  run = true,
) {
  useEffect(() => {
    if (run) {
      const options = {
        ...passedOptions,
        PDFJS_URL: `${process.env.PUBLIC_URL}/pdfviewer/web/viewer.html`,
        forcePDFJS: true,
      };
      PDFObject.embed(endpoint, embedId, options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [embedId, endpoint, run]);
}

export default useEmbedPdf;
